import React from 'react';
import { MailIcon, CheckCircleIcon } from 'lucide-react';
import { OPS_DISTRIBUTION_EMAIL } from '../utils/mockData';
interface EmailStatusProps {
  timestamp: string;
  snapshotFilename: string;
  missingCount: number;
}
export function EmailStatus({
  timestamp,
  snapshotFilename,
  missingCount
}: EmailStatusProps) {
  const formattedTime = new Date(timestamp).toLocaleString('en-US', {
    dateStyle: 'medium',
    timeStyle: 'short'
  });
  return <section aria-label="Email notification status" data-id="element-22">
      <div className="bg-green-50 border border-green-200 rounded-lg p-5" data-id="element-23">
        <div className="flex items-start gap-4" data-id="element-24">
          <div className="flex-shrink-0 w-11 h-11 rounded-full bg-green-100 flex items-center justify-center" data-id="element-25">
            <MailIcon className="w-5 h-5 text-green-600" aria-hidden="true" data-id="element-26" />
          </div>
          <div className="flex-1" data-id="element-27">
            <div className="flex items-center gap-2 mb-1" data-id="element-28">
              <h3 className="text-sm font-semibold text-green-800" data-id="element-29">
                Report Emailed to Operations
              </h3>
              <CheckCircleIcon className="w-4 h-4 text-green-600" aria-hidden="true" data-id="element-30" />
            </div>
            <div className="space-y-1" data-id="element-31">
              <p className="text-xs text-green-700" data-id="element-32">
                <span className="font-medium" data-id="element-33">Recipient:</span>{' '}
                {OPS_DISTRIBUTION_EMAIL}
              </p>
              <p className="text-xs text-green-700" data-id="element-34">
                <span className="font-medium" data-id="element-35">Sent:</span> {formattedTime}
              </p>
              <p className="text-xs text-green-700" data-id="element-36">
                <span className="font-medium" data-id="element-37">Attachments:</span> Missing Loans
                CSV ({missingCount} records), Run Audit CSV
              </p>
              <p className="text-xs text-green-700" data-id="element-38">
                <span className="font-medium" data-id="element-39">Snapshot:</span>{' '}
                {snapshotFilename}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}